import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-educational-trips',
  templateUrl: './educational-trips.component.html',
  styleUrls: ['./educational-trips.component.scss']
})
export class EducationalTripsComponent implements OnInit {

  tripImages = [
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (1).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (2).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (3).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (4).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (5).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (6).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (7).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (8).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (9).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (10).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (11).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (12).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (13).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (14).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (15).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (16).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (17).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (18).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (19).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (20).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (21).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (22).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (23).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (24).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (25).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (26).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (27).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (28).jpg' },
    { title: 'Educational Trip', location: 'Study Tour', img: '/assets/img/quick-links/eductaional-trips/1 (29).jpg' },
  ];

  constructor() { }

  ngOnInit(): void { }

}
